import React from "react";
import { motion } from "framer-motion";
import { CONTACT } from "@/data/content";

const INSTAGRAM_URL = "https://www.instagram.com/mergulhobc";

export default function SocialFloat() {
  return (
    <div className="fixed right-4 z-[60] flex flex-col gap-3 sm:right-6" style={{ bottom: "1.5rem" }}>
      {/* Instagram (on top) */}
      <motion.a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.35, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="flex h-14 w-14 items-center justify-center rounded-full shadow-2xl shadow-black/25 sm:h-16 sm:w-16"
        style={{
          background:
            "linear-gradient(45deg,#F58529 0%,#DD2A7B 45%,#8134AF 75%,#515BD4 100%)",
        }}
        aria-label="Seguir no Instagram @mergulhobc"
        data-testid="instagram-float"
      >
        <svg viewBox="0 0 24 24" className="h-7 w-7 fill-white sm:h-8 sm:w-8" aria-hidden="true">
          <path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2Zm0 1.8c-3.15 0-3.5.01-4.74.07-1.07.05-1.65.23-2.03.38-.51.2-.87.44-1.25.82-.38.38-.62.74-.82 1.25-.15.38-.33.96-.38 2.03C2.72 8.5 2.71 8.85 2.71 12s.01 3.5.07 4.74c.05 1.07.23 1.65.38 2.03.2.51.44.87.82 1.25.38.38.74.62 1.25.82.38.15.96.33 2.03.38 1.24.06 1.59.07 4.74.07s3.5-.01 4.74-.07c1.07-.05 1.65-.23 2.03-.38.51-.2.87-.44 1.25-.82.38-.38.62-.74.82-1.25.15-.38.33-.96.38-2.03.06-1.24.07-1.59.07-4.74s-.01-3.5-.07-4.74c-.05-1.07-.23-1.65-.38-2.03-.2-.51-.44-.87-.82-1.25-.38-.38-.74-.62-1.25-.82-.38-.15-.96-.33-2.03-.38C15.5 4.01 15.15 4 12 4Zm0 3.05a4.95 4.95 0 1 1 0 9.9 4.95 4.95 0 0 1 0-9.9Zm0 1.8a3.15 3.15 0 1 0 0 6.3 3.15 3.15 0 0 0 0-6.3Zm5.15-2.16a1.16 1.16 0 1 1 0 2.32 1.16 1.16 0 0 1 0-2.32Z" />
        </svg>
      </motion.a>

      {/* WhatsApp (below) */}
      <motion.a
        href={CONTACT.whatsappFloatLink}
        target="_blank"
        rel="noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/40 sm:h-16 sm:w-16"
        aria-label="Falar no WhatsApp"
        data-testid="whatsapp-float"
      >
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white sm:h-8 sm:w-8" aria-hidden="true">
          <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.712 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.233 1.588h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.71 12.71 0 0 0 16.003 3.2Zm0 23.04h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.05 1.07-3.9-.253-.4a10.56 10.56 0 0 1-1.62-5.63c0-5.87 4.777-10.646 10.65-10.646 2.845 0 5.518 1.108 7.53 3.12a10.58 10.58 0 0 1 3.117 7.53c0 5.872-4.777 10.65-10.65 10.65Zm5.84-7.976c-.32-.16-1.894-.935-2.188-1.042-.293-.107-.507-.16-.72.16-.214.32-.826 1.042-1.013 1.256-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.95-.848-1.593-1.895-1.78-2.215-.186-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.214.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.095-1.12 2.67 0 1.575 1.147 3.097 1.307 3.31.16.214 2.253 3.44 5.46 4.826.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.894-.774 2.16-1.522.267-.747.267-1.388.187-1.522-.08-.133-.293-.213-.613-.373Z" />
        </svg>
      </motion.a>
    </div>
  );
}
